module.exports = __webpack_public_path__ + "static/media/image_55.4504fd66.png";